import { routeConfig } from "@/routes/route";
import { campaignCenterRouterMap, useCampaignCenterRouterMap } from "./campaignCenter/router";
import { Suspense, lazy } from "react";
import { QualificationPages } from "../Qualification/router";
import { useTranslation } from "react-i18next";

const LazyLoad = (path: string) => {
  const Comp = lazy(() => import("@BZA/" + path));
  return (
    <Suspense fallback={<></>}>
      <Comp />
    </Suspense>
  );
};

export const useToolCenterRoutes = () => {
  const { t } = useTranslation();
  const campaignCenterRoutes = useCampaignCenterRouterMap();

  return [
    {
      path: "/toolset",
      name: t("Basics.LeftMenu.ToolCenter"),
      key: "repairKey",
      icon: "Repair",
      element: LazyLoad("ToolCenter/index"),
      children: [
        {
          path: "qualification",
          name: t("Basics.LeftMenu.QualificationVerification"),
          key: "certificationKey",
          element: LazyLoad("Qualification/list"),
        },
        ...QualificationPages,
        ...campaignCenterRoutes,
        {
          path: "ket",
          name: t("Basics.LeftMenu.WordTranslationTool"),
          key: "extendedWordKey",
          element: LazyLoad("ToolCenter/keywordExpansion/index"),
        },
      ],
    },
  ];
};

// 静态路由配置（用于向后兼容）
export const ToolCenterRouterMap: routeConfig[] = [
  {
    path: "/toolset",
    name: "工具中心",
    key: "repairKey",
    icon: "Repair",
    element: LazyLoad("ToolCenter/index"),
    children: [
      {
        path: "qualification",
        name: "资质验证",
        key: "certificationKey",
        element: LazyLoad("Qualification/list"),
      },
      ...QualificationPages,
      ...campaignCenterRouterMap,
      {
        path: "ket",
        name: "拓词工具",
        key: "extendedWordKey",
        element: LazyLoad("ToolCenter/keywordExpansion/index"),
      },
    ],
  },
];

export const CIDToolCenterRouterMap: routeConfig[] = [
  {
    path: "/toolset",
    name: "工具中心",
    key: "repairKey",
    icon: "Repair",
    element: LazyLoad("ToolCenter/index"),
    children: [
      {
        path: "ket",
        name: "拓词工具",
        key: "extendedWordKey",
        element: LazyLoad("ToolCenter/keywordExpansion/index"),
      },
    ],
  },
];

export const useCIDToolCenterRoutes = () => {
  const { t } = useTranslation();

  return [
    {
      path: "/toolset",
      name: t("Basics.LeftMenu.ToolCenter"),
      key: "repairKey",
      icon: "Repair",
      element: LazyLoad("ToolCenter/index"),
      children: [
        {
          path: "ket",
          name: t("Basics.LeftMenu.WordTranslationTool"),
          key: "extendedWordKey",
          element: LazyLoad("ToolCenter/keywordExpansion/index"),
        },
      ],
    },
  ];
};
